import { PAGE_KINDS } from "../shared/constants/pageAgentIds";
import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { isRefusal, optionalString, refuse, requiredString, type FrontendTool } from "./frontendTool";

/** Paints a field's extraction evidence in the source document pane. */
export const highlightSourceTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.highlightSource,
  declaration: (location, caseReview) => location?.page !== PAGE_KINDS.caseReview || caseReview === null ? null : {
    name: FRONTEND_TOOL_NAMES.highlightSource,
    description: "Highlight where in the source document a field's value was read from.",
    parameters: {
      type: "object",
      properties: { fieldId: { type: "string" }, recordId: { type: "string" } },
      required: ["fieldId"],
    },
  },
  execute: (args, env) => {
    const fieldId = requiredString(args, "fieldId");
    if (isRefusal(fieldId)) return fieldId;
    const recordId = optionalString(args, "recordId");
    if (isRefusal(recordId)) return recordId;
    if (env.caseReview === null) return refuse(FRONTEND_TOOL_CODES.outOfScope, "No case is open on this screen.");
    if (!env.caseReview.highlightSource(fieldId, recordId ?? null)) {
      return refuse(FRONTEND_TOOL_CODES.invalidValue, `${fieldId} has no source location on the screen.`);
    }
    return { ok: true, fieldId };
  },
};
